export const PDV_PLATFORM_ID = 1
